module.exports = __webpack_public_path__ + "static/img/15.10215f77.png";